"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.takeLatest = exports.takeEvery = exports.debounce = void 0;
exports.takeLatestByProp = takeLatestByProp;
exports.throttle = exports.takeLeading = void 0;
var _effects = _interopRequireWildcard(require("redux-saga/effects"));
var sagaEffects = _effects;
var _errorHandler = _interopRequireDefault(require("./errorHandler"));
var _logger = _interopRequireDefault(require("./logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var logger = new _logger.default('saga:effects');
var onError = e => {
  logger.error('utils:sagas:onError', e);
  _errorHandler.default.captureException(e, 'utils:sagas', e);
};
var safe = function safe(handler, saga) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  return function* (action) {
    try {
      yield (0, _effects.call)(saga, ...args, action);
    } catch (err) {
      yield (0, _effects.call)(handler, ...args, err, action);
    }
  };
};
var debounce = exports.debounce = function debounce(ms, pattern, saga) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    args[_key2 - 3] = arguments[_key2];
  }
  return sagaEffects.debounce(ms, pattern, safe(onError, saga), ...args);
};
var takeEvery = exports.takeEvery = function takeEvery(pattern, saga) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    args[_key3 - 2] = arguments[_key3];
  }
  return sagaEffects.takeEvery(pattern, safe(onError, saga), ...args);
};
var takeLatest = exports.takeLatest = function takeLatest(pattern, saga) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
    args[_key4 - 2] = arguments[_key4];
  }
  return sagaEffects.takeLatest(pattern, safe(onError, saga), ...args);
};
var takeLeading = exports.takeLeading = function takeLeading(pattern, saga) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
    args[_key5 - 2] = arguments[_key5];
  }
  return sagaEffects.takeLeading(pattern, safe(onError, saga), ...args);
};
var throttle = exports.throttle = function throttle(ms, pattern, saga) {
  for (var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
    args[_key6 - 3] = arguments[_key6];
  }
  return sagaEffects.throttle(ms, pattern, safe(onError, saga), ...args);
};

/**
 * generic function to have a takelatest by a property of the action payload
 * eg: takeLatestByProp(WRTC_ON_PC_STREAM_CHANGE, 'token', handlePeerStreamChange)
 * it will takeLatest on WRTC_ON_PC_STREAM_CHANGE combine with token property
 * could be equivalent to:
 *  takeLatest(`${WRTC_ON_PC_STREAM_CHANGE}${action.payload.token}`, handlePeerStreamChange)
 */
function takeLatestByProp(actionType, property, asyncFunction) {
  var activeTasks = {};
  function* watchAction() {
    var _loop = function* _loop() {
      var _action$payload;
      var action = yield sagaEffects.take(actionType);
      var id = (action === null || action === void 0 || (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload[property]) || 'default';
      if (activeTasks[id]) {
        logger.warn('utils:sagas:takeLatestByProp: Cancel  %s with prop %s=%s', actionType, property, id);
        yield sagaEffects.cancel(activeTasks[id]);
      }
      activeTasks[id] = yield sagaEffects.fork(function* () {
        try {
          // logger.debug(
          //     'utils:sagas:takeLatestByProp: Register %s with prop %s=%s',
          //     actionType,
          //     property,
          //     id,
          // );
          yield sagaEffects.call(asyncFunction, action);
        } finally {
          // logger.debug(
          //     'utils:sagas:takeLatestByProp: Deleting %s with prop %s=%s',
          //     actionType,
          //     property,
          //     id,
          // );
          delete activeTasks[id];
        }
      });
    };
    while (true) {
      yield* _loop();
    }
  }
  return watchAction;
}